<template>
  <div
    id="baisc-config"
    v-loading.fullscreen="loading"
    class="app-main-content"
    element-loading-text=""
    element-loading-spinner="none"
    element-loading-background="rgba(170,170,170,0)"
    style="flex-grow:1;display:flex;flex-direction:column"
  >
    <div class="app-main-inner-tab" style="flex-grow:1;display:flex;flex-direction:column">
      <el-tabs v-model="activeTabName" type="card" style="width:100%" @tab-click="handleTabClick">
        <el-tab-pane :label="$t('CargoMsg.Cargo_TemplateManagement')" name="templateManagement">
          <template-management />
        </el-tab-pane>
        <el-tab-pane v-if="isAdmin" :lazy="true" :label="$t('CargoMsg.Cargo_TemplateTypeManagement')" name="templateTypeManagement">
          <template-type-management />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_ConfigurationManagement')" name="configurationManagement">
          <configuration-management />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_MappingManagement')" name="mappingManagement">
          <mapping-management />
        </el-tab-pane>
        <el-tab-pane v-if="isSysAdmin" :lazy="true" :label="$t('CargoMsg.Cargo_InitializeTemplateManagement')" name="tabInitTemplateManage">
          <init-template-manage />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_BusinessStatusManagement')" name="businessStatusManagement">
          <tenant-business-status-management ref="businessStatusManagement" />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_TriggerTypeManagement')" name="triggerTypeManagement">
          <trigger-type-management />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_FileTypeManagement')" name="documentTypeManagement">
          <document-type-management />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_DefaultValueManagement')" name="defaultManagement">
          <default-management />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_ValidationRuleConfiguration')" name="checkRuleConf">
          <check-rule-conf />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_EDITemplateSettings')" name="EDITemplateSettings">
          <edi-template-settings />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_WarnRuleConfiguration')" name="warnRuleConfiguration">
          <warn-rule-configuration />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_OnlineShippingOrderSettings')" name="settingUpOfShippingOnlineCounter">
          <setting-up-of-shipping-online-counter />
        </el-tab-pane>
        <el-tab-pane v-if="isAutomaticFeeToSubJob" :lazy="true" :label="$t('CargoMsg.Cargo_ChargeAutomaticAllocationConfig')" name="automaticAllocationConfig">
          <automatic-allocation-config />
        </el-tab-pane>
        <!--        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_RouteAndWarehouseConfiguration')" name="routeWarehouseConfiguration">-->
        <!--          <route-and-warehouse-configuration />-->
        <!--        </el-tab-pane>-->
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_BPMApprovalProcess')" name="bpmApprovalProcess">
          <div v-if="isPlatform">
            <bpm-approval-process-advance-setting />
          </div>
          <div v-else>
            <bpm-approval-process />
          </div>
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_PushServiceConfiguration')" name="pushConfiguration">
          <push-configuration />
        </el-tab-pane>
        <!-- CARGO-25396 系统维护-【基本配置】-「到期客户通知」页签 移至 销售-【CRM设置】 -->
        <!--        <el-tab-pane :lazy="true" label="到期客户通知" name="customerNotificationConfiguration">-->
        <!--          <customer-notification-configuration />-->
        <!--        </el-tab-pane>-->
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_CustomInvoiceRemarks')" name="diyInvoiceRemark">
          <diy-invoice-remark />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_EmailTemplateManagement')" name="MailBoxManagement">
          <mail-box-management />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_BillOfLadingConfiguration')" name="putASingleRule">
          <put-a-single-rule />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Financial_Archiving_Settings')" name="financialArchivingSettings">
          <financial-archiving-settings />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('SeaExport.DocumentRecognitionSettings')" name="ocrRecordSet">
          <ocr-record-set />
        </el-tab-pane>
        <el-tab-pane v-if="isPlatform" :lazy="true" :label="$t('CargoMsg.CARGO_RECOGNITION_SETTING')" name="ocrRecognitionSetting">
          <ocr-recognition-setting />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_ServiceLockSettings')" name="serviceLockSetting">
          <service-lock-setting />
        </el-tab-pane>
        <el-tab-pane v-if="isZY && $checkPermission(['tab_MTConfig_ChinaPostProductConfiguration'])" :lazy="true" :label="$t('CargoMsg.ChinaPostProductConfiguration')" name="ChinaPostProductConfiguration">
          <ChinaPostProductConfiguration />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.CustomFieldDisplayConfiguration')" name="CustomFieldDisplayConfiguration">
          <customFieldDisplayConfiguration />
        </el-tab-pane>
        <el-tab-pane v-if="isPlatform" :lazy="true" :label="$t('CargoMsg.VASChannelSetting')" name="VASChannelSetting">
          <VAS-channel-setting />
        </el-tab-pane>
        <el-tab-pane v-if="isPlatform" :lazy="true" :label="$t('CargoMsg.AnalyzeChannelSettings')" name="AnalyzeChannelSettings">
          <Analyze-channel-settings />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_BookingChannelConfig')" name="bookingChannelConfig">
          <booking-channel-config />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_ImperialUnits')" name="imperialUnits">
          <imperial-units-setting />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_ReleaseNumberConfigTab')" name="releaseNumberConfig">
          <release-number-config />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_ProfitShareConfig')" name="profitShareConfig">
          <profit-share-config />
        </el-tab-pane>
        <el-tab-pane :lazy="true" label="交叉委托加价规则" name="crossDelegationMarkupRule">
          <cross-delegation-markup-rule ref="crossDelegationMarkupRule" />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_InternalFeeMarkupRuleConfig')" name="internalFeeMarkupRule">
          <internal-fee-markup-rule />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import TemplateManagement from './components/basicConfig/templateManagement'
import InitTemplateManage from './components/basicConfig/initTemplateManage'
import MappingManagement from './components/basicConfig/mappingManagement'
import TriggerTypeManagement from './components/basicConfig/triggerTypeManagement'
import DefaultManagement from './components/basicConfig/defaultManagement'
import SettingUpOfShippingOnlineCounter from './components/basicConfig/settingUpOfShippingOnlineCounter'
import EdiTemplateSettings from './components/basicConfig/ediTemplateSettings'
import CheckRuleConf from './components/basicConfig/checkRuleConf'
import PushConfiguration from './components/basicConfig/pushConfiguration'
import DiyInvoiceRemark from './components/basicConfig/diyInvoiceRemark'
import customerNotificationConfiguration from './components/basicConfig/customerNotificationConfiguration'
import DocumentTypeManagement from './components/basicConfig/documentTypeManagement'
import TemplateTypeManagement from './components/basicConfig/templateTypeManagement'
import ConfigurationManagement from './components/basicConfig/configurationManagement'
import MailBoxManagement from './components/basicConfig/mailboxManagement'
import putASingleRule from './components/basicConfig/putASingleRule'
import ServiceLockSetting from './components/basicConfig/serviceLockSetting'
import ImperialUnitsSetting from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/imperialUnitsSetting.vue'
import ReleaseNumberConfig from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/releaseNumberConfig.vue'
import WarnRuleConfiguration from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/warnRuleConfiguration/index'
import TenantBusinessStatusManagement
from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/tenantBusinessStatusManagement/index'
import BpmApprovalProcess from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/bpmApprovalProcess/index'
import BpmApprovalProcessAdvanceSetting from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/bpmApprovalProcessAdvanceSetting/index'
import FinancialArchivingSettings
from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/financialArchivingSettings.vue'
import OcrRecordSet from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/ocrRecordSet'
import OcrRecognitionSetting from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/ocrRecognitionSetting'
import ChinaPostProductConfiguration from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/chinaPostProductConfiguration/chinaPostProductConfiguration.vue'
import CustomFieldDisplayConfiguration from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/customFieldDisplayConfiguration/customFieldDisplayConfiguration.vue'
import VASChannelSetting from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/VASChannelSetting.vue'
import { cacheName, cache } from '@/utils/cacheManager'
import AnalyzeChannelSettings from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/AnalyzeChannelSettings.vue'
import AutomaticAllocationConfig from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/automaticAllocationConfig.vue'
import BookingChannelConfig from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/bookingChannelConfig.vue'
import { ACTIVE_TAB_NAME_BUSINESS_STATUS_MANAGEMENT } from '@/class/cargo/model/parameters/SystemConstants'
import ProfitShareConfig from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/profitShareConfig/index'
import CrossDelegationMarkupRule from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/crossDelegationMarkupRule/index'
import InternalFeeMarkupRule from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/internalFeeMarkupRule/index'

export default {
  name: 'BasicConfig',
  components: {
    ImperialUnitsSetting,
    ReleaseNumberConfig,
    OcrRecordSet,
    FinancialArchivingSettings,
    TenantBusinessStatusManagement,
    WarnRuleConfiguration,
    DocumentTypeManagement,
    PushConfiguration,
    customerNotificationConfiguration,
    TriggerTypeManagement,
    MappingManagement,
    TemplateManagement,
    DefaultManagement,
    SettingUpOfShippingOnlineCounter,
    EdiTemplateSettings,
    TemplateTypeManagement,
    ConfigurationManagement,
    CheckRuleConf,
    DiyInvoiceRemark,
    InitTemplateManage,
    MailBoxManagement,
    putASingleRule,
    BpmApprovalProcess,
    BpmApprovalProcessAdvanceSetting,
    OcrRecognitionSetting,
    ChinaPostProductConfiguration,
    ServiceLockSetting,
    CustomFieldDisplayConfiguration,
    VASChannelSetting,
    AnalyzeChannelSettings,
    AutomaticAllocationConfig,
    BookingChannelConfig,
    ProfitShareConfig,
    CrossDelegationMarkupRule,
    InternalFeeMarkupRule
  },
  data() {
    return {
      loading: false,
      activeTabName: 'templateManagement',
      isZY: false
    }
  },
  computed: {
    isSysAdmin() {
      return this.$store.getters.userInfo.userType === 1
    },
    isAdmin() {
      return this.$store.getters.isAdmin
    },
    isPlatform() {
      return this.$store.getters.tenantId === 1
    },
    isAutomaticFeeToSubJob() { // 主单费用自动分摊到小票
      return cache.config && parseInt(cache.config.get('AutomaticFeeToSubJob')) === 1
    }
  },
  mounted() {
    this.isZY = String(cache.config.get('ToExoSystem')) === 'zy'
  },
  methods: {
    handleTabClick() {
      this.$nextTick(() => {
        if (this.activeTabName === ACTIVE_TAB_NAME_BUSINESS_STATUS_MANAGEMENT.code) {
          this.$refs.businessStatusManagement.initTenantInstructionAndRule()
        }
        // 切换到交叉委托加价规则页签时加载数据
        if (this.activeTabName === 'crossDelegationMarkupRule') {
          this.$refs.crossDelegationMarkupRule.loadData()
        }
      })
    }
  }
}
</script>

<style lang="scss">
#app #baisc-config .app-main-page{
  height: calc(100vh - 100px);
}
#baisc-config {
  .el-tabs {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    .el-tabs__content {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      .el-tab-pane {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
      }
    }
  }
}
</style>
